<div class="toolbar">
  <div class="toolbar-identity"><ng-content select="[noteHeaderIdentity]" /></div>
  <div class="toolbar-actions"><ng-content select="[noteHeaderActions]" /></div>
</div>
<div class="divider"></div>
<div class="lead"><ng-content select="[noteHeaderIcon]" /></div>
<div class="title"><ng-content select="[noteHeaderTitle]" /></div>
<div class="dates"><ng-content select="[noteHeaderDates]" /></div>
<div class="tabs">
  <ng-content select="[noteHeaderTabs]" />
  <span class="tabs-filler"></span>
  <ng-content select="[noteHeaderKnowledge]" />
</div>
